// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"fa6ded08","880":"046e5111"}[chunkId] + ".chunk.js";
};